import { Injectable } from '@angular/core';

import { BrowserService } from 'webcommon/legacy-common';
import {
  CustomerLicenseAsset,
  RegistrationCustomerLicenseNames,
  CustomerLicenseAssetsDto,
} from 'webcommon/shared';

@Injectable({
  providedIn: 'root',
})
export class TinyMceService {
  private enableSpellCheck = false;
  private loadedPlugins = false;
  private readonly documentObj: Document;

  constructor(
    browserService: BrowserService,
  ) {
    this.documentObj = browserService.getDocument();
  }

  isSpellCheckEnabled(): boolean {
    return this.enableSpellCheck;
  }

  load(customerLicenseAssets?: CustomerLicenseAssetsDto): Promise<void> {
    const tinyMceAsset = customerLicenseAssets?.Assets[RegistrationCustomerLicenseNames.TinyMce];
    return this.setSpellCheckEnabled(tinyMceAsset);
  }

  private loadPlugins(): Promise<void> {
    this.loadedPlugins = true;

    return new Promise<void>((resolve, reject) => {
      const script = this.documentObj.createElement('script');
      script.onload = () => {
        resolve();
      };
      script.onerror = (e) => {
        reject(e);
      };
      // TODO: get API key from license asset
      script.src = 'https://cdn.tiny.cloud/1/bprbjc3lrrj2zyfn0g5qmabe84o6mcngzxcl5hwo2gf6d02h/tinymce/6/plugins.min.js';
      script.referrerPolicy = 'origin';
      this.documentObj.head.appendChild(script);
    });
  }

  private setSpellCheckEnabled(asset?: CustomerLicenseAsset): Promise<void> {
    this.enableSpellCheck = asset?.IsEnabled ?? false;

    if (this.enableSpellCheck && !this.loadedPlugins) {
      return this.loadPlugins();
    }
    return Promise.resolve();
  }
}
